import React from 'react';

export default function Locations() {
  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">📍 Our Locations</h2>


      {/* Canada */}
      <h4 className="text-primary">🇨🇦 Canada</h4>
      <p><strong>Winnipeg:</strong> 312, 2525 Pembina Hwy</p>
      <div className="mb-4">
        <iframe
          title="Winnipeg Office"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2839.719354037122!2d-97.14707942355525!3d49.79425807148902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x52ea73a7bb40ec71%3A0xfbe003ec025da957!2s2525%20Pembina%20Hwy%2C%20Winnipeg%2C%20MB%20R3T%202H4!5e0!3m2!1sen!2sca!4v1684621594836!5m2!1sen!2sca"
          width="100%" height="250" style={{ border: 0 }} allowFullScreen="" loading="lazy"
        ></iframe>
      </div>

      <p><strong>Saskatoon:</strong> 507, 103 Klassen Crescent</p>
      <div className="mb-5">
        <iframe
          title="Saskatoon Office"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2447.7750156776774!2d-106.72478372461342!3d52.15660116307248!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5304f79fbb0e81d5%3A0x5e1078503d7751c7!2s103%20Klassen%20Crescent%20%23507%2C%20Saskatoon%2C%20SK%20S7R%200J2!5e0!3m2!1sen!2sca!4v1751947167465!5m2!1sen!2sca"
          width="100%"
          height="250"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

    </div>
  );
}
